import { combineReducers } from 'redux';

import adminInspectionList from 'views/Admin/Inspection/List/reducer';
import adminInspectionWorkspace from 'views/Admin/Inspection/reducer';
import adminPanel from 'views/Admin/stalled/reducer';
import adminTestPlanReducer from 'views/Admin/TestPlan/reducer';
import adminTestItemReducer from 'views/Admin/TestLines/reducer';
import companyProfileWorkspace from 'views/CompanyProfile/reducer';
import companyProfileUpdateWorkspace from 'views/CompanyProfile/update/reducer';
import inspectionDefectCategories from 'views/Inspection/DefectCategories/reducer';
import inspectionJobDetailWorkspace from 'views/Inspection/Job/Details/reducer';
import inspectionList from 'views/Inspection/Job/List/reducer';
import inspectionJobWorkspace from 'views/Inspection/Job/reducer';
import iSource from 'views/iSource/reducer';
import loginReducer from 'views/Login/reducer';
import registrationReducer from 'views/Registration/reducer';
import productTestingReducer from 'views/ProductTesting/reducer';
import supplierInvitation from 'views/SupplierInvitation/reducer';
import supplierManager from 'views/SupplierManager/reducer';
import factoryAuditReducer from 'views/FactoryAudit/reducer';
import dashboardReducer from 'views/Dashboard/reducer';
import landingPage from 'views/LandingPage/reducer';
import payerReducer from 'views/PayerList/reducer';
import testPlanReducer from 'views/TestPlan/reducer';
import sharedReducer from 'shared/reducer';
import addProduct from 'views/AddProduct/reducer';
import desktopReview from 'views/DesktopReview/redux/reducer';
import productTestingV1 from 'views/ProductTesting/redux/reducer';
import documentManagement from 'views/DocumentManagement/redux/reducer';
import documentManagementSupplier from 'views/DocumentManagement/redux/supplierReducer';
import qcInspection from 'views/Inspection/redux/reducer';
import newDashboard from 'views/NewDashboard/reducer';
import accountManagement from 'views/AccountManagement/reducer';
import supplierManagement from 'views/SupplierManager/newStore/reducer';
import smFactoryDetail from 'views/SupplierManager/newStore/factoryDetail/reducer';
import productDetail from 'views/ProductDetail/reducer';
import inspectionReducer from 'views/Inspection/reducer';
import buyerInspection from 'modules/inspection/redux/reducer';
import company from 'modules/company/redux/reducers';
import productTesting from 'modules/product-testing/redux/reducers';
import TicMartReducer, { REDUCER_KEY as TICMART_REDUCER_KEY } from 'modules/ticmart/redux/reducers';
import desktopReviewModule, {
  REDUCER_KEY as DESKTOP_REVIEW_REDUCER_KEY,
} from 'modules/desktop-review/redux/reducers';
import {
  DESKTOP_REVIEW_INVOICE_REDUCER_KEY,
  DesktopReviewInvoiceReducer,
} from 'modules/desktop-review/redux/invoice/index';
import auditCertificationList from './auditCertificationList';
import bibleList from './bibleList';
import career from './career';
import careerInvite from './careerInvite';
import companies from './companies';
import loginState from './loginState';
import messageCenter from './messageCenter';
import notifications from './notificationMessage';
import notificationSettings from './notificationSettings';
import privacySetting from './privacySetting';
import productCategoryList from './productCategoryList';
import productManagerList from './productManager/productManagerList';
import productManagerProfile from './productManager/productManagerProfile';
import purchaseOrderList from './purchaseOrderList';
import reportUploadWorkspace from './reportUploadWorkspace';
import tags from './tags';
import wechatLogin from './wechatLogin';
import country from './country';
import AppReducer from './app/index';

export default combineReducers({
  adminInspectionList,
  adminInspectionWorkspace,
  adminPanel,
  adminTestPlanReducer,
  adminTestItemReducer,
  companyProfileWorkspace,
  companyProfileUpdateWorkspace,
  inspectionDefectCategories,
  inspectionJobDetailWorkspace,
  inspectionList,
  inspectionJobWorkspace,
  iSource,
  loginReducer,
  registrationReducer,
  supplierInvitation,
  supplierManager,
  auditCertificationList,
  bibleList,
  career,
  careerInvite,
  companies,
  loginState,
  messageCenter,
  notifications,
  notificationSettings,
  privacySetting,
  productCategoryList,
  productManagerList,
  productManagerProfile,
  purchaseOrderList,
  reportUploadWorkspace,
  tags,
  wechatLogin,
  productTestingReducer,
  sharedReducer,
  factoryAuditReducer,
  dashboardReducer,
  payerReducer,
  testPlanReducer,
  addProduct,
  productDetail,
  country,
  supplierManagement,
  smFactoryDetail,
  inspectionReducer,
  buyerInspection,
  company,
  accountManagement,
  productTesting,
  [TICMART_REDUCER_KEY]: TicMartReducer,
  [DESKTOP_REVIEW_REDUCER_KEY]: desktopReviewModule,
  desktopReview,
  documentManagement,
  newDashboard,
  [DESKTOP_REVIEW_INVOICE_REDUCER_KEY]: DesktopReviewInvoiceReducer,
  landingPage,
  qcInspection,
  documentManagementSupplier,
  productTestingV1,
  app: AppReducer,
});
